module.exports = __webpack_public_path__ + "static/Testimonial_Prof.Adlassnig-5682f1b2f6f7b0e9780c82c033d9d5cf.png";